// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mI3Cw","question":"styles_question__3gFRF","description":"styles_description__2JW17"};